import React, { Component } from "react";
import { Tag } from "antd";

const { CheckableTag } = Tag;

export default class DayTag extends Component {
  state = { checked: false };

  handleChange = checked => {
    this.props.handleDailyChange(false);
    this.setState({ checked });
  };

  render() {
    return (
      <CheckableTag
        {...this.props}
        checked={
          this.state.checked
          // this.props.dailychecked && this.props.dailychecked == "true"
          //   ? false
          //   : this.state.checked
        }
        // className={
        //   this.props.dailychecked && this.props.dailychecked == "true"
        //     ? "disabled"
        //     : ""
        // }
        onChange={this.handleChange}
      >
        {this.props.children}
      </CheckableTag>
    );
  }
}
